module.exports = __webpack_public_path__ + "img/icon_15.2f0959bb.gif";